import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import ComparisonTable from "../components/ComparisonTable";
import WhyEdgely from "../components/WhyEdgely";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { COMPARISON_TABLES } from "../data/comparisonPages";
import { buildWebPageLd } from "../../shared/seoJsonLd";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/alternatives-journal-de-trading";

export default function AlternativesPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.comparisons.alternatives;
  return (
    <MarketingPageLayout>
      <SeoHelmet
        path={PATH}
        title={m.title}
        description={m.description}
        jsonLd={[buildWebPageLd({ name: m.title, description: m.description, path: PATH })]}
      />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <ComparisonTable columns={COMPARISON_TABLES.alternatives} />
      <WhyEdgely points={c.why} />
      <InternalLinks
        links={[
          { to: "/vs/tradezella", label: t.marketing.comparisons.tradezella.h1 },
          { to: "/meilleur-journal-de-trading", label: t.marketing.comparisons.best.h1 },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
